




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { MigrationImport } from "@/entities";
import { StringIterator } from "lodash";

const namespace: string = "migration";

@Component({
  components: {
    LeftNavigationComponent,
  },
})
export default class ImportSummaryComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  progressBar: boolean = false;
  importSuccessful: boolean = true;
  buttonStatus: string = "Finish Import";
  isDisabled: boolean = false;
  status: string = "";
  importedId = _app.migrationImportStatus.imported;

  snackbar: boolean = false;
  message: string = "";
  snackBarColor: string = "red";

  importProcess() {
    this.isDisabled = true;
    this.progressBar = true;
    this.buttonStatus = this.$t("Importing...").toString();
    this.status = this.$t("Import process started...").toString();

    this.$services.migration
      .import(this.migration.MigrationImportId)
      .then((resp) => {
        if (resp.status && resp.status >= 400) {
          // Show error
          this.progressBar = false;
          this.isDisabled = false;
          this.buttonStatus = this.$t("Finish Import").toString();

          this.snackbar = true;
          this.snackBarColor = "red";

          if (Array.isArray(resp.data)) {
            this.message = resp.data.join("<br/ >");
          } else {
            this.message =
              resp.status == 401 || resp.status == 403
                ? this.$t("User does not have permission")
                : resp.data;
          }
        } else {
          // Show success
          this.progressBar = false;
          this.importSuccessful = false;
          this.snackbar = true;
          this.snackBarColor = "green";
          this.buttonStatus = this.$t("Data imported").toString();
          this.message = this.$t("Data imported successfully.").toString();
        }
      });
  }
}
